/** Shared coaching line on WWW + Hat **Final turn recap** screens (before the leaderboard). */
export const FINAL_TURN_RECAP_NEXT_STEPS =
  "When you're ready, tap Final scores below to see the final scores.";
